import ProcessIMG1 from  '../../../assets/images/nas-process-1.png'
import ProcessIMG2 from  '../../../assets/images/nas-process-2.png'
import ProcessIMG3 from  '../../../assets/images/nas-process-3.png'
import ProcessIMG4 from  '../../../assets/images/nas-process-4.png'
import ProcessIMG5 from  '../../../assets/images/nas-process-5.png'
import ProcessMobile1 from '../../../assets/images/itm01.png';
import ProcessMobile2 from '../../../assets/images/itm02.png';
import ProcessMobile3 from '../../../assets/images/itm03.png';
import ProcessMobile4 from '../../../assets/images/itm04.png';
import ProcessMobile5 from '../../../assets/images/itm05.png';

import { Service } from './types';

export const services: Service[] = [
  {
    id: 1,
    icon: ProcessMobile1,
    mobileIcon: ProcessMobile1,
    alt: 'IT Monleys NAS Synology',
    title: 'I. Analyse et conseil d\'architecture',
    titleKey: 'appCloud.timeline.services.0.title',
    description: 'Analyse technique de vos applications afin de vous conseiller sur l\'architecture applicative la plus adaptée.',
    descriptionKey: 'appCloud.timeline.services.0.description',
    link: '/#',
    features: [
      { text: '' },
      { text: "Analyse des besoins applicatifs.", textKey: 'appCloud.timeline.services.0.features.1' },
      { text: 'Conseil sur l\'architecture applicative.', textKey: 'appCloud.timeline.services.0.features.2' },
      { text: 'Évaluation des coûts et des ressources.', textKey: 'appCloud.timeline.services.0.features.3' },
    ],
  },
  {
    id: 2,
    icon: ProcessMobile2,
    mobileIcon: ProcessMobile2,
    alt: 'Cybersecurity Icon',
    title: 'II. Intégration simplifiée',
    titleKey: 'appCloud.timeline.services.1.title',
    description: 'Intégration fluide et efficace de votre application dans le cloud. Automatisation des tâches répétitives.',
    descriptionKey: 'appCloud.timeline.services.1.description',
    link: '/#',
    features: [
      { text: '' },
      { text: 'Intégration par étapes.', textKey: 'appCloud.timeline.services.1.features.1' },
      { text: 'Automatisation des tâches répétitives.', textKey: 'appCloud.timeline.services.1.features.2' },
      { text: 'Déploiements reproductibles et automatisés.', textKey: 'appCloud.timeline.services.1.features.3' },
    ],
  },
  {
    id: 3,
    icon: ProcessMobile3,
    mobileIcon: ProcessMobile3,
    alt: 'Cloud Service Icon',
    title: 'III. Orchestration du déploiement',
    titleKey: 'appCloud.timeline.services.2.title',
    description: 'IT Monkeys prend en charge l\'ensemble du processus de déploiement. Intégration harmonieuse et sécurisée de votre application dans le cloud.',
    descriptionKey: 'appCloud.timeline.services.2.description',
    link: '/#',
    features: [
      { text: '' },
      { text: "Déploiement progressif.", textKey: 'appCloud.timeline.services.2.features.1' },
      { text: 'Rollback rapide en cas de problème détecté.', textKey: 'appCloud.timeline.services.2.features.2' },
      { text: 'Suivi performances, détection rapide d\'anomalies.', textKey: 'appCloud.timeline.services.2.features.3' }
    ],
  },
  {
    id: 4,
    icon: ProcessMobile4,
    mobileIcon: ProcessMobile4,
    alt: 'OpenAI Icon',
    title: 'IV. Déploiement et tests',
    titleKey: 'appCloud.timeline.services.3.title',
    description: 'Déployez de nouvelles fonctionnalités et testez des innovations instantanément. Les déploiements deviennent rapides, faciles et sans contraintes.',
    descriptionKey: 'appCloud.timeline.services.3.description',
    link: '/#',
    features: [
      { text: '' },
      { text: 'Déploiement continu pour agilité maximale.', textKey: 'appCloud.timeline.services.3.features.1' },
      { text: 'Collecte retours pour améliorations continues.', textKey: 'appCloud.timeline.services.3.features.2' },
      { text: 'Expérimentation de nouvelles fonctionnalités.', textKey: 'appCloud.timeline.services.3.features.3' },
    ],
  },
  {
    id: 5,
    icon: ProcessMobile5,
    mobileIcon: ProcessMobile5,
    alt: 'Training Icon',
    title: 'V. Sécurité et conformité',
    titleKey: 'appCloud.timeline.services.4.title',
    description: 'La sécurité est intégrée à chaque étape de notre approche. Nous mettons en place des protocoles robustes pour protéger vos applications et vos données.',
    descriptionKey: 'appCloud.timeline.services.4.description',
    link: '/training',
    features: [
      { text: '' },
      { text: 'Sécurité by Design.', textKey: 'appCloud.timeline.services.4.features.1' },
      { text: 'Authentification forte, gestion des accès.', textKey: 'appCloud.timeline.services.4.features.2' },
      { text: 'Chiffrement des données.', textKey: 'appCloud.timeline.services.4.features.3' },
    ],
  },
];
